import styled from 'styled-components';
import { Button } from 'react-bootstrap';

// ページ全体のラッパー
export const Wrapper = styled.div`
  overflow-x: auto;
  min-height: 100vh;
  background-color: #F5F7F7;
  position: relative;
`;

// 固定ヘッダー無しのシンプルなページのヘッダー
export const SimpleHead = styled.h1`
  text-align: center;
  color: white;
  background-color: #232F3E;
  font-size: 20px;
  margin: 0 0 20px 0;
  height: 40px;
  line-height: 40px;
  a {
    color: white;
    text-decoration: none;
  }
`;

// 必須
export const Req = styled.span`
  color: #dc3545;
`;


// フォームエラーメッセージ
export const ErrorMsg = styled.span`
  color: #dc3545;
  &::before {
    content: '※';
  }
`;

// フォームエラーメッセージ（検索ワードのインライン部分用）
export const ErrorMsgInline = styled.span`
  margin: 5px 0;
  color: #dc3545;
  float: left;
  &::before {
    content: '※';
  }
`;

// リロードボタン
export const ReloadButton = styled(Button)`
  color: #212529;
  padding: 0;
`;

// アイコンボタン
export const IconButton = styled.button`
  background-color: transparent;
  border: 0px;
  outline: none !important;
`;

export const Dl = styled.dl`
  width: 100%;
  display: table;
  margin-bottom: 0px;
`;

export const Dt = styled.dt`
  width: 220px;
  display: table-cell;
  padding-top: 13px;
  padding-bottom: 13px;
  padding-left: 12px;
  border: 1px solid #dee2e6;
`;

export const Dd = styled.dd`
  display: table-cell;
  margin-bottom: 0;
  padding-top: 10px;
  padding-left: 12px;
  border: 1px solid #dee2e6;
  text-align: left;
`;